'use client';

import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from 'react';
import { LayoutGroup } from 'motion/react';
export function MorphDialogGroup(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <LayoutGroup>{children}</LayoutGroup>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}